import React from 'react';
import { Shield, Clock, DollarSign, Users } from 'lucide-react';
interface WhyChooseProps {
  language: 'en' | 'es';
}
export function WhyChoose({
  language
}: WhyChooseProps) {
  const content = {
    en: {
      title: 'Why Choose Sparrow Advance',
      subtitle: 'Real solutions. Real speed. Real people who understand business owners.',
      features: [{
        icon: Shield,
        title: 'Business-Only',
        description: 'Funding for registered U.S. companies with a business checking account.'
      }, {
        icon: Clock,
        title: '$25K to $5M+',
        description: 'Use it for payroll, ads, inventory, or expansion.'
      }, {
        icon: DollarSign,
        title: 'No Credit Pull',
        description: 'Safe for your score during pre-qualification.'
      }, {
        icon: Users,
        title: '24-Hour Funding',
        description: 'Direct to your business account.'
      }]
    },
    es: {
      title: 'Por Qué Elegir Sparrow Advance',
      subtitle: 'Soluciones reales. Velocidad real. Personas reales que entienden a los dueños de negocios.',
      features: [{
        icon: Shield,
        title: 'Solo para Negocios',
        description: 'Financiamiento para empresas estadounidenses registradas con cuenta de cheques comercial.'
      }, {
        icon: Clock,
        title: '$25K a $5M+',
        description: 'Úselo para nómina, anuncios, inventario o expansión.'
      }, {
        icon: DollarSign,
        title: 'Sin Revisión de Crédito',
        description: 'Seguro para su puntaje durante la precalificación.'
      }, {
        icon: Users,
        title: 'Fondos en 24 Horas',
        description: 'Directamente a su cuenta comercial.'
      }]
    }
  };
  const t = content[language];
  return <section className="w-full py-20 bg-gradient-to-b from-white via-gray-50 to-[#E8F0F8]" data-id="element-376">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-377">
        <div className="text-center mb-16" data-id="element-378">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#142B44] mb-4" data-id="element-379">
            {t.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-380">
            {t.subtitle}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-381">
          {t.features.map((feature, index) => <div key={index} className="group bg-white p-8 rounded-2xl border-2 border-gray-100 hover:border-[#2D5D9F] transition-all duration-300 hover:shadow-2xl hover:-translate-y-2" data-id="element-382">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#142B44] to-[#2D5D9F] text-white rounded-2xl mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg" data-id="element-383">
                <feature.icon size={28} strokeWidth={2} data-id="element-384" />
              </div>
              <h3 className="text-xl font-bold text-[#142B44] mb-4 leading-tight group-hover:text-[#2D5D9F] transition-colors" data-id="element-385">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-386">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}